import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-unpaid-outstanding-vbriefly',
  templateUrl: './unpaid-outstanding-vbriefly.component.html',
  styleUrl: './unpaid-outstanding-vbriefly.component.scss'
})

export class UnpaidOutstandingVbrieflyComponent {

  
    onlyOutstandingInDetailFormBeans: any;
    
    
    
     constructor(
          private dialogRef: MatDialogRef<UnpaidOutstandingVbrieflyComponent>,
          @Inject(MAT_DIALOG_DATA) public data: any,
          private service: DigisubservicesService,
          private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
        ) {
         
        }
    
    reportType:any
      startDate :any
      endDate :any
      repName :any
      offRepName:any
      advtName :any
      issueDates:any
      issueDates1:any
      onlyOutstandingVB:any
    
      OutStandingIDTotal: number = 0;
      OutStandingIDNetAmtTotal: number = 0;
      OutStandingIDUnPaidTotal: number = 0;
      currentDate: Date;
      onlytotalAdvtAmount: number;
      onlytotalNetAmount: number;
      onlytotalUnpaidAmount: number;
      onlygstUnpaidAmount :number;
      onlyrcvUnpaidAmount :number;
      onlytotalGstUnpaidAmount : number;
      onlytotalRcvUnpaidAmount :number;
  
      ngOnInit(): void {
    
        this.currentDate = new Date();
        debugger
        this.reportType = this.data['reportType'];
        this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
        this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
        this.repName = this.data['repName'];
        this.offRepName = this.data['offRepName'];
        this.advtName = this.data['name'];
        this.issueDates = this.data.issueDates;
        this.issueDates1 = this.data['issue_date'];
    
        const req: any = {
          "rep_name":  this.repName,
          "start_date": this.startDate,
          "end_date": this.endDate,
          "off_rep_name": this.offRepName,
          "advt_name": this.data['name'],
          // // "issue_name" : this.advtName,
          // "issue_date": this.issueDates
          "issue_name": "",
          "issue_date": this.issueDates1
    
    
        }

//          this.service.getonlyOutstandingVB(req).subscribe((data: any) => {
//       this.onlyOutstandingVB = data as any;

//       // Reset totals
//       this.onlytotalAdvtAmount = 0;
//       this.onlytotalNetAmount = 0;
//       this.onlytotalUnpaidAmount = 0;
//       this.onlytotalGstUnpaidAmount = 0;
//       this.onlytotalRcvUnpaidAmount = 0 ;

//       // Calculate totals
//    for (let repData of this.onlyOutstandingVB) {
//   for (let data1 of repData.rep_data) {
//     for (let data2 of data1.advtdata) {
//       this.onlytotalAdvtAmount += parseFloat(data2.contract_bkng_advt_amt) || 0;
//       this.onlytotalGstUnpaidAmount += parseFloat(data2.contract_gst_amt) || 0;
//       this.onlytotalNetAmount += parseFloat(data2.contract_net_total) || 0;
//       this.onlytotalRcvUnpaidAmount += parseFloat(data2.contract_rcv_amt) || 0;
//       this.onlytotalUnpaidAmount += parseFloat(data2.contract_bal_amt) || 0;
//     }
//   }
// }

//     });


this.service.getonlyOutstandingVB(req).subscribe((data: any) => {
  this.onlyOutstandingVB = data as any;

  // Reset totals
  this.onlytotalAdvtAmount = 0;
  this.onlytotalNetAmount = 0;
  this.onlytotalUnpaidAmount = 0;
  this.onlytotalGstUnpaidAmount = 0;
  this.onlytotalRcvUnpaidAmount = 0;

  // Calculate totals
  for (let offRep of this.onlyOutstandingVB) {
    offRep.adv_total = 0;
    offRep.gst_total = 0;
    offRep.net_total = 0;
    offRep.rcv_total = 0;
    offRep.bal_total = 0;

    for (let repData of offRep.rep_data) {
      // initialize rep totals
      repData.adv_total = 0;
      repData.gst_total = 0;
      repData.net_total = 0;
      repData.rcv_total = 0;
      repData.bal_total = 0;

      for (let data2 of repData.advtdata) {
        const advtAmt = parseFloat(data2.contract_bkng_advt_amt) || 0;
        const gstAmt = parseFloat(data2.contract_gst_amt) || 0;
        const netAmt = parseFloat(data2.contract_net_total) || 0;
        const rcvAmt = parseFloat(data2.contract_rcv_amt) || 0;
        const balAmt = parseFloat(data2.contract_bal_amt) || 0;

        // accumulate rep totals
        repData.adv_total += advtAmt;
        repData.gst_total += gstAmt;
        repData.net_total += netAmt;
        repData.rcv_total += rcvAmt;
        repData.bal_total += balAmt;

        // accumulate offrep totals
        offRep.adv_total += advtAmt;
        offRep.gst_total += gstAmt;
        offRep.net_total += netAmt;
        offRep.rcv_total += rcvAmt;
        offRep.bal_total += balAmt;

        // accumulate grand totals
        this.onlytotalAdvtAmount += advtAmt;
        this.onlytotalGstUnpaidAmount += gstAmt;
        this.onlytotalNetAmount += netAmt;
        this.onlytotalRcvUnpaidAmount += rcvAmt;
        this.onlytotalUnpaidAmount += balAmt;
      }
    }
  }
});


}


exportExcel(fileName): void {
  console.log('Export function called with fileName:', fileName);
  
  let element = document.getElementById('print-section');
  console.log('Element found:', element);
  
  if (!element) {
    console.error('Element with ID "print-section" not found in DOM');
    return;
  }
  
  try {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    console.log('Worksheet created:', ws);
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
    XLSX.writeFile(wb, fileName + '.xlsx');
    console.log('File should be downloaded');
  } catch (error) {
    console.error('Error during export:', error);
  }
}


}